import MainAW from '../pages/main-aw/index'
import Progress from '../pages/progress/index'
import Gallery from '../pages/gallery/index'
import History from '../pages/history/index'
import Documents from '../pages/documents/index'
import Location from '../pages/location/index'
import FloorPlan from '../pages/floor-plan/index'

import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)
export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/history',
      name: 'history',
      component: History
    },
    {
      path: '/',
      name: 'MainAW',
      component: MainAW
    },
    {
      path: '/progress',
      name: 'Progress',
      component: Progress
    },
    {
      path: '/gallery',
      name: 'Gallery',
      component: Gallery
    },
    {
      path: '/documents',
      name: 'Documents',
      component: Documents
    },
    {
      path: '/location',
      name: 'Location',
      component: Location
    },
    {
      path: '/floor-plan',
      name: 'Floor Plan',
      component: FloorPlan
    },
  ]
})
